import React from 'react';
import { monetaryClaimsSteps } from '../data/sharedSteps';
import { PAGE_META } from '../data/pageMetaConfig';

const path = '/monetary-claims-lawyer';

export const pageMeta = {
  title: PAGE_META[path].title,
  metaDescription: PAGE_META[path].description,
  path,
  h1: 'עורך דין תביעות כספיות',
  faqSubtitle: 'מצאו תשובות לשאלות נפוצות בנוגע לתביעות כספיות, כתבי הגנה וגביית חובות.',
};

export const steps = monetaryClaimsSteps;

export const faq = [
  {
    question: 'מתי כדאי להגיש תביעה כספית?',
    answer:
      'כדאי לבחון תביעה כאשר יש חוב או נזק כספי שניתן להוכיח באמצעות מסמכים, הסכם, התכתבויות, קבלות, חשבוניות או ראיות אחרות.',
  },
  {
    question: 'כמה זמן לוקחת תביעה כספית?',
    answer:
      'משך ההליך משתנה לפי סכום התביעה, מורכבות המקרה, עומס בית המשפט, מספר הדיונים והאם הצדדים מגיעים להסכמות בדרך.',
  },
  {
    question: 'האם אפשר להגיע להסדר גם אחרי שהוגשה תביעה?',
    answer:
      'כן. במקרים רבים ניתן לנהל משא ומתן ולהגיע להסכמות גם לאחר פתיחת ההליך, אם הדבר מתאים לנסיבות המקרה.',
  },
  {
    question: 'האם אפשר לתבוע בלי הסכם כתוב?',
    answer:
      'במקרים מסוימים כן, אבל חשוב לבדוק אילו ראיות קיימות — התכתבויות, העברות בנקאיות, חשבוניות, עדים או מסמכים אחרים שיכולים לתמוך בטענה.',
  },
];

export const sections = [
  {
    title: 'חייבים לכם כסף? חשוב לפעול נכון מהשלב הראשון',
    content: (
      <>
        <p>
          אם מישהו חייב לכם כסף ולא משלם, אם לקוח הפר הסכם, אם נגרם לכם נזק כספי או אם קיבלתם
          דרישה לתשלום שאתם לא מסכימים איתה – חשוב לבדוק את המצב לפני שפועלים לבד. הרבה
          אנשים מחכים יותר מדי זמן. שולחים הודעות, מנסים לדבר, מקבלים הבטחות, ובינתיים הזמן
          עובר והחוב לא משולם. מצד שני, יש גם אנשים שממהרים להגיש תביעה בלי לבדוק אם יש מספיק
          ראיות, מסמכים או בסיס משפטי.
        </p>
        <p>
          תביעה כספית היא הדרך לפנות לבית המשפט כשמישהו חייב לכם כסף, לא שילם לכם או גרם לכם
          לנזק כספי. כדי להתחיל את ההליך, מגישים כתב תביעה שמסביר מי הצדדים, מה קרה, כמה כסף
          אתם דורשים ועל מה הדרישה מבוססת.
        </p>
        <p>
          במשרד מיכלסון ושות׳ אנחנו מלווים לקוחות בהגשת תביעות כספיות, הכנת כתבי תביעה, הגשת
          כתבי הגנה, איסוף מסמכים וראיות, ניהול משא ומתן וניהול ההליך עד לשלב פסק הדין או
          הגעה להסכמות במקרים המתאימים. המטרה שלנו היא פשוטה: לבדוק את המקרה, להבין מה ניתן
          לדרוש, לבחון את הסיכויים והסיכונים, ולבנות תכנית פעולה מסודרת.
        </p>
      </>
    ),
  },
  {
    title: 'אילו סוגי תביעות כספיות קיימים?',
    content: (
      <>
        <p>תביעות כספיות יכולות להגיע ממגוון רחב של מצבים. במשרדנו ניתן לבחון ליווי במקרים כגון:</p>
        <ul>
          <li>חוב כספי שלא שולם.</li>
          <li>הפרת חוזה או התחייבות.</li>
          <li>אי־תשלום עבור שירות או עבודה.</li>
          <li>סכסוכים בין עסקים.</li>
          <li>תביעה בגין הלוואה שלא הוחזרה.</li>
          <li>דרישות תשלום בין אנשים פרטיים.</li>
          <li>תביעות נגד לקוחות או ספקים.</li>
          <li>הגנה מפני תביעה כספית שהוגשה נגדכם.</li>
          <li>ניהול משא ומתן להסדר כספי.</li>
        </ul>
        <p>כל מקרה נבחן לפי העובדות, המסמכים והראיות שקיימות בפועל.</p>
      </>
    ),
  },
  {
    title: 'איך עורך דין תביעות כספיות יכול לעזור?',
    content: (
      <>
        <p>
          עורך דין לתביעות כספיות לא רק כותב כתב תביעה. התפקיד שלו הוא לבדוק את המקרה, לבחון
          את הראיות, להבין את הסיכויים והסיכונים, ולבחור את הדרך הנכונה לניהול ההליך. במשרדנו
          הליווי כולל בין היתר:
        </p>
        <h3>בדיקת המקרה והמסמכים</h3>
        <p>
          בשלב הראשון אנחנו בודקים מה קרה, מה סכום הדרישה, אילו מסמכים קיימים, האם יש הסכם,
          התכתבויות, חשבוניות, קבלות, העברות בנקאיות או ראיות נוספות. המטרה היא להבין האם יש
          בסיס אמיתי לתביעה, ומה ניתן לדרוש.
        </p>
        <h3>גיבוש אסטרטגיה משפטית</h3>
        <p>
          לא כל מקרה צריך להגיע מיד לבית משפט. לפעמים נכון לשלוח מכתב דרישה. לפעמים נכון לנסות
          משא ומתן. לפעמים כדאי להגיש תביעה. ולפעמים צריך דווקא להתגונן בצורה מסודרת מפני
          תביעה לא מוצדקת. אנחנו בונים את דרך הפעולה לפי המקרה, סכום החוב, הראיות, הצד השני
          והסיכויים המשפטיים.
        </p>
        <h3>ניסוח והגשת כתב תביעה</h3>
        <p>
          כתב תביעה צריך להיות ברור, מסודר ומבוסס על עובדות, מסמכים ועילה משפטית. כתב תביעה
          לא מדויק או לא מבוסס עלול להקשות על ניהול ההליך. לכן חשוב להציג את הסיפור בצורה
          מסודרת, לצרף את המסמכים הרלוונטיים ולנסח בצורה נכונה מה הסכום שאתם דורשים ועל מה
          הוא מבוסס.
        </p>
        <h3>הגשת כתב הגנה</h3>
        <p>
          אם הוגשה נגדכם תביעה כספית, חשוב לא להתעלם. כתב הגנה הוא ההזדמנות שלכם להציג את
          הטענות, לצרף מסמכים, ולהסביר למה אין מקום לחייב אתכם בסכום הנתבע או מדוע יש להפחיתו.
          אם הוגשה נגדכם תביעה, חשוב לבדוק באיזה בית משפט מתנהל ההליך ומה המועד להגשת כתב
          הגנה. איחור בהגשת כתב הגנה עלול לפגוע באפשרות שלכם להתגונן כמו שצריך.
        </p>
        <h3>ניהול משא ומתן והגעה להסכמות</h3>
        <p>
          במקרים רבים, גם אחרי שנפתח הליך, ניתן לבחון הגעה להסכמות. לפעמים הסדר נכון יכול
          לחסוך זמן, עלויות ואי־ודאות. לכן אנחנו בוחנים בכל שלב האם נכון להמשיך בהליך או לנסות
          להגיע לפתרון מוסכם.
        </p>
        <h3>ליווי עד פסק דין או הסדר</h3>
        <p>
          המטרה היא לא רק להגיש מסמך לבית המשפט, אלא ללוות אתכם לאורך ההליך: כתבי טענות,
          דיונים, בקשות, ניהול ראיות, משא ומתן והגעה לפסק דין או הסכם במקרים המתאימים.
        </p>
      </>
    ),
  },
];
